// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconStar2 = createRemixIcon('IconStar2', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 .084l3.934 7.983L23.917 12l-7.983 3.933L12 23.916l-3.933-7.983l-7.983-3.932l7.983-3.934zm0 5.656L9.934 9.934L5.74 12l4.193 2.066L12 18.26l2.066-4.194L18.26 12l-4.194-2.066z\" clip-rule=\"evenodd\"/>");
